import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M82.0299 1.60001C82.0299 1.60001 94.0998 -1.54999 99.1998 7.88001C107.79 23.73 95.5698 52.14 101.84 72.94C106.82 89.45 95.7299 88.3 92.7599 84.99C88.0699 79.78 89.9498 74.59 89.9498 74.59C89.9498 74.59 83.3398 78.55 80.6998 70.63C78.0598 62.71 83.7099 50.07 85.6499 43.38C87.5999 36.69 95.4998 8.16002 82.8398 7.55002L82.0299 1.60001Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M85.1599 4.91001C85.1599 4.91001 97.0499 3.59003 97.5499 20.93C98.0499 38.27 90.7799 55.28 95.8999 72.29C98.8799 82.19 96.8899 86.4901 94.4099 85.6701"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M85.6599 7.21997C85.6599 7.21997 95.3998 7.54998 93.7498 24.23C92.0998 40.91 83.5099 52.3 89.1299 58.08C89.1299 58.08 81.0399 70.96 87.3099 75.09"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M22.2198 1.60001C22.2198 1.60001 10.1499 -1.54999 5.04992 7.88001C-3.54008 23.73 8.67991 52.14 2.40991 72.94C-2.57009 89.45 8.51986 88.3 11.4899 84.99C16.1799 79.78 14.2999 74.59 14.2999 74.59C14.2999 74.59 20.9099 78.55 23.5499 70.63C26.1899 62.7 20.5398 50.07 18.5998 43.38C16.6498 36.69 8.74991 8.16002 21.4099 7.55002L22.2198 1.60001Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M19.0897 4.91001C19.0897 4.91001 7.19965 3.59003 6.69965 20.93C6.19965 38.27 13.4697 55.28 8.34968 72.29C5.36968 82.19 7.35967 86.4901 9.83967 85.6701"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M18.5897 7.21997C18.5897 7.21997 8.84976 7.54998 10.4998 24.23C12.1498 40.91 20.7398 52.3 15.1198 58.08C15.1198 58.08 23.2097 70.96 16.9397 75.09"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
